import { ApiError } from "../api";

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  let message = "Something went wrong.";
  let status: number | null = null;
  if (error instanceof ApiError) {
    message = error.message;
    status = error.status;
  } else if (error instanceof Error) {
    message = error.message;
  }
  return (
    <div className="err-box" role="alert">
      <strong>Error{status ? ` (${status})` : ""}:</strong> {message}
    </div>
  );
}
